/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Weight from './weight';
import WeightDetail from './weight-detail';
import WeightUpdate from './weight-update';
import WeightDeleteDialog from './weight-delete-dialog';

const WeightRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Weight />} />
    <Route path="new" element={<WeightUpdate />} />
    <Route path=":id">
      <Route index element={<WeightDetail />} />
      <Route path="edit" element={<WeightUpdate />} />
      <Route path="delete" element={<WeightDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WeightRoutes;
